import { useEffect } from "react";
import { Link } from "react-router-dom";
import clsx from "clsx";
import { useTranslation } from "react-i18next";
import Button from "../../ui/Button";

const NAVBAR_OFFSET = 90;

const MobileMenu = ({ open, onClose, links, sections }) => {
  const { t } = useTranslation("landing");

  useEffect(() => {
    if (!open) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);

    return () => {
      document.body.style.overflow = prev;
      window.removeEventListener("keydown", onKey);
    };
  }, [open, onClose]);

  const handleClick = (e, link) => {
    const ref = sections?.[link.target];
    if (ref?.current) {
      e.preventDefault();
      const top =
        ref.current.getBoundingClientRect().top +
        window.scrollY -
        NAVBAR_OFFSET;
      window.scrollTo({ top, behavior: "smooth" });
    }
    onClose();
  };

  return (
    <div
      aria-hidden={!open}
      className={clsx(
        "fixed inset-x-0 top-[78px] z-40 flex flex-col gap-1 border-b border-line bg-surface px-6 py-5",
        "transition-all duration-300 ease-snap lg:hidden",
        open
          ? "translate-y-0 visible opacity-100"
          : "-translate-y-[120%] invisible opacity-0"
      )}
    >
      {links.map((link) => (
        <a
          key={link.key}
          href={link.anchor}
          onClick={(e) => handleClick(e, link)}
          className="border-b border-line py-3 text-base font-semibold text-ink transition-colors hover:text-teal-2 dark:hover:text-teal-3"
        >
          {t(`nav.${link.key}`)}
        </a>
      ))}

      <Link
        to="/login"
        onClick={onClose}
        className="py-2 text-center text-base font-semibold text-ink-soft transition-colors hover:text-teal-2"
      >
        {t("nav.login")}
      </Link>

      <Button
        as={Link}
        to="/login"
        onClick={onClose}
        variant="primary"
        className="mt-2 w-full"
      >
        {t("nav.start")}
      </Button>
    </div>
  );
};

export default MobileMenu;